import { Loader2, ShieldAlert } from "lucide-react";
import * as React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { oidcCallback } from "@/services/auth";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const savedState = sessionStorage.getItem("facet_oidc_state");
    const redirectUri = sessionStorage.getItem("facet_oidc_redirect_uri") || window.location.origin + "/auth/callback";

    if (!code) {
      setError("授权回调缺少 code 参数");
      return;
    }

    if (state && savedState && state !== savedState) {
      setError("state 校验失败，请重新登录");
      return;
    }

    oidcCallback(code, redirectUri)
      .then(() => {
        sessionStorage.removeItem("facet_oidc_state");
        sessionStorage.removeItem("facet_oidc_code_verifier");
        sessionStorage.removeItem("facet_oidc_redirect_uri");
        navigate("/", { replace: true });
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : "OIDC 登录失败");
      });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-950 p-4 text-white">
        <ShieldAlert className="h-12 w-12 text-destructive" />
        <h1 className="text-xl font-semibold">登录失败</h1>
        <p className="max-w-md text-center text-sm text-slate-400">{error}</p>
        <Button onClick={() => (window.location.href = "/login")}>返回登录页</Button>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-950 text-white">
      <Loader2 className="h-8 w-8 animate-spin text-indigo-500" />
      <p className="text-sm text-slate-400">正在完成登录…</p>
    </div>
  );
}
